export const modes = {
  INPUT: 0,
  BASIC: 1
};

export const state = {
    ready: true,
    currentInput: [],
    showCursor: true,
    blockCursor: false,
    waitingForKeyPress: false,
    loadedProgram: null,
    loadedDirectory: null,
    maxValue: 1.70141183e38,
    maxLineLength: 40,
    maxStringLength: 255,
    running: false,
    goto: null,
    maxGoto: 63999,
    mode: modes.INPUT,
    start: new Date()
  };